import React from "react";
import FAQAccordion from "@/components/FAQAccordion";

export default function CityFAQSection({ cityName, faqs }) {
  return (
    <div className="bg-white p-6 rounded border border-gray-200">
      <h3 className="font-display tracking-widest uppercase text-base mb-3">FAQ for {cityName} Homeowners</h3>
      <FAQAccordion faqs={faqs} />
    </div>
  );
}
